__turbopack_context__.v({
  "arrow": "NewsCarousel-module-scss-module__Kdf6LW__arrow",
  "arrowIcon": "NewsCarousel-module-scss-module__Kdf6LW__arrowIcon",
  "arrowNext": "NewsCarousel-module-scss-module__Kdf6LW__arrowNext",
  "arrowPrev": "NewsCarousel-module-scss-module__Kdf6LW__arrowPrev",
  "carouselImage": "NewsCarousel-module-scss-module__Kdf6LW__carouselImage",
  "carouselItem": "NewsCarousel-module-scss-module__Kdf6LW__carouselItem",
  "carouselLink": "NewsCarousel-module-scss-module__Kdf6LW__carouselLink",
  "carouselTitleWrap": "NewsCarousel-module-scss-module__Kdf6LW__carouselTitleWrap",
  "carouselWrap": "NewsCarousel-module-scss-module__Kdf6LW__carouselWrap",
  "dot": "NewsCarousel-module-scss-module__Kdf6LW__dot",
  "dotActive": "NewsCarousel-module-scss-module__Kdf6LW__dotActive",
  "dots": "NewsCarousel-module-scss-module__Kdf6LW__dots",
});
